import React from 'react';
import classNames from 'classnames';
import { Modal as AntdModal, ModalFuncProps } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { ModalProps as AntdModalProps } from 'antd/lib/modal';

import cn from './styles.module.scss';

export interface ModalProps extends AntdModalProps {
  top?: string;
  closeClassName?: string;
  onClose?: AntdModalProps['onCancel'],
  children?: React.ReactNode,
}

export const Modal = ({
  top, onClose, className, closeClassName, ...props
}: ModalProps) => (
  <AntdModal
    onCancel={onClose}
    maskClosable={false}
    className={classNames(cn.modal, className)}
    closeIcon={(
      <div className={classNames(cn.close, closeClassName)}>
        <CloseOutlined />
      </div>
    )}
    style={{ top }}
    destroyOnHidden
    footer={null}
    mask={{
      blur: false
    }}
    {...props}
  />
);

export const confirm = (modalProps: ModalFuncProps) => {
  const { okButtonProps, cancelButtonProps } = modalProps;
  return AntdModal.confirm({
    icon: null,
    okText: 'Confirm',
    mask: {
      blur: false,
    },
    okButtonProps: {
      type: 'primary',
      ...okButtonProps,
    },
    cancelButtonProps: {
      color: 'primary',
      variant: 'outlined',
      ...cancelButtonProps,
    },
    ...modalProps,
  });
};
